var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createRef } from 'react';
import { Header } from '@app/Components/Header/Header';
import { HeaderLimited } from '@app/Components/HeaderLimited/HeaderLimited';
import { Router } from 'react-router-dom';
import styles from './App.module.scss';
import './reset.scss';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { RouteWrapper } from './RouteWrapper';
import { browserHistory } from './History';
import { requestTimelineService } from './Services/RequestTimelineService';
import { appStore } from '@app/AppStore';
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary';
import { NotificationContainer } from '@app/Components/ToastNotification/ToastNotification';
import { ColorBlindModeModal } from '@app/Widgets/ColorBlindModeModal/ColorBlindModeModal';
import { colorThemesStore } from '@app/Stores/ColorThemesStore';
import { LoadingContext } from '@app/Context/LoadingContext';
import { Footer } from './Components/Footer/Footer';
export var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._header = createRef();
        _this._footer = createRef();
        _this._showColorBlindModeModal = true;
        return _this;
    }
    App.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestTimelineService.init();
                        return [4 /*yield*/, appStore.loadAppPermissions()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, colorThemesStore.loadColorTheme()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    App.prototype._getContainerStyles = function () {
        var _a, _b, _c, _d;
        var paddingTop = (((_b = (_a = this._header) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0) + 30;
        var minHeight = "calc(100% - ".concat(((_d = (_c = this._footer) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.offsetHeight) || 0, "px)");
        return {
            paddingTop: paddingTop,
            minHeight: minHeight
        };
    };
    App.prototype.render = function () {
        var _this = this;
        var isInitColorThemeNotSet = colorThemesStore.isInitColorThemeNotSet;
        return (React.createElement(Router, { history: browserHistory },
            React.createElement("div", { className: styles.body },
                React.createElement("div", { className: styles.header, ref: this._header }, window.location.pathname.startsWith('/task-info/') ? React.createElement(HeaderLimited, null) : React.createElement(Header, null)),
                React.createElement("div", { className: styles.container, style: this._getContainerStyles() },
                    React.createElement(ErrorBoundary, null,
                        React.createElement(NotificationContainer, null),
                        React.createElement(RouteWrapper, null))),
                React.createElement("div", { className: styles.footer, ref: this._footer },
                    React.createElement(Footer, null)),
                React.createElement(ColorBlindModeModal, { isOpen: isInitColorThemeNotSet && this._showColorBlindModeModal, toggleModal: function () { return (_this._showColorBlindModeModal = !_this._showColorBlindModeModal); }, isShowInfo: true }))));
    };
    App.contextType = LoadingContext;
    __decorate([
        observable
    ], App.prototype, "_header", void 0);
    __decorate([
        observable
    ], App.prototype, "_footer", void 0);
    __decorate([
        observable
    ], App.prototype, "_showColorBlindModeModal", void 0);
    App = __decorate([
        observer
    ], App);
    return App;
}(React.PureComponent));
